module.exports = __webpack_public_path__ + "img/port-de-la-daurade.e343a334.jpg";